import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'gdp-line-item',
  templateUrl: './line-item.component.html',
  styleUrls: ['./line-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LineItemComponent implements OnInit {
  @Input() item: any;
  @Input() locale: string;
  @Input() currency: string;
  @Input() showItemData: boolean = false;
  @Input() planData: any;
  public planFullPrice: number;

  ngOnInit(): void {
    // to show the full price if there is discount
    if (this.planData?.meta_data?.pricing_info?.discount_type === "per_user") {
      this.planFullPrice =
        this.item.total_amount + this.planData.meta_data.pricing_info.discount_amount * this.item.quantity;
    }
    if (this.planData?.meta_data?.pricing_info?.discount_type === "absolute") {
      this.planFullPrice =
        this.item.total_amount + this.planData.meta_data.pricing_info.discount_amount;
    }
  }

  get showItemQuantity() {
    return this.item.pricing_model !== 'flat_fee' || this.item.quantity > 1;
  }
}